<script>

    import { Lightbox } from 'svelte-lightbox';
    import {decode} from "html-entities";

    export let config;
    export let contentID;
    export let listView;
    export let classes;

    function loadThumbnail(cid) {
        return fetch(config.model_root + 'shared/files/load_spotlight_images.php?c=' + cid, {
            method: "GET"
        })
            .then(response => response.json());
    }

    function loadFiles(content) {
        return fetch(config.model_root + 'shared/files/load_files.php?c=' + content + '&t=image', {
            method: "GET"
        })
            .then(response => response.json());
    }

</script>

{#await loadFiles(contentID)}
    <div class="d-flex justify-content-center bg-light {classes.placeholder}">
        <div class="spinner-grow text-secondary justify-content-center align-self-center" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>

{:then items}
    {#if items.length >= 1}
        <div class="{classes.thumbnail}">
            {#if listView}
                <img src="{config.application_root}files/{items[0].fpath}" alt="{items.fname}">
            {:else}

                {#each items as image}

                    {#if image.fthumbnail == 1 || image.fspotlight == 1}
                        <div class="gallery-item rounded overflow-hidden mb-1">
                            <Lightbox description="{image.fname}" imagePreset="fit" modalClasses="gallery-item-modal">
                                <img src="{config.application_root}files/{image.fpath}" alt="{decode(image.fname)}">
                            </Lightbox>
                        </div>
                    {/if}

                {/each}

            {/if}
        </div>
    {:else}
        <div class="d-flex justify-content-center bg-light {classes.placeholder}">
            <i class="far fa-file-image text-darkgreen justify-content-center align-self-center">
                <span class="sr-only">Kein Vorschaubild vorhanden</span>
            </i>
        </div>
    {/if}
{:catch error}
    <div class="d-flex justify-content-center bg-light {classes.placeholder}">
        <i class="fas fa-exclamation-triangle text-warning justify-content-center align-self-center">
            <span class="sr-only">Error loading thumbnail: {error}</span>
        </i>
    </div>
{/await}

<style>
    .gallery-item img {
        width: 100%;
        height: auto;
        object-fit: cover;
    }
    .gallery-item img:hover {
        filter: brightness(70%);
    }
    :global(.gallery-item-modal img) {
        height: 100%;
        max-height: 80vh;
        max-width: 90vw;
    }
</style>
